import { render, staticRenderFns } from "./OpportunityList.vue?vue&type=template&id=a800ce9a&"
import script from "./OpportunityList.vue?vue&type=script&lang=js&"
export * from "./OpportunityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports